import React from 'react';
import { deburr } from 'lodash';

import { ReactComponent as BonusCheck } from 'theme/assets/images/bonus-check.svg';
import NewSigningCardFooter, { INewSigningCardFooterProps } from '../NewSigningCardFooter';
import CardFace from 'components/CardFace';
import './NewSigningCard.scss';

export interface INewSigningCardProps {
  selected: boolean;
  teamCode: string;
  displayName: string;
  position: string;
  shirtNumber: string;
  teamName: string;
  footerDetails: INewSigningCardFooterProps;
  onPlayerSelect: () => void;
}

const NewSigningCard: React.FC<INewSigningCardProps> = (props) => {
  const selectedIconStyle = props.selected ? 'new-signing-card__icon--selected' : '';
  const selectedCardStyle = props.selected ? 'new-signing-card__body--selected' : '';

  return (
    <div className="new-signing-card">
      <div className={`new-signing-card__icon ${selectedIconStyle}`}>
        <BonusCheck width={16} height={16} />
      </div>
      <div className={`new-signing-card__body ${selectedCardStyle}`} onClick={props.onPlayerSelect}>
        <CardFace
          teamCode={props.teamCode}
          playerName={deburr(props.displayName)}
          details={{ team: props.teamName, position: props.position, playerNo: props.shirtNumber, style: 'new-signing-card__details' }}
        />
      </div>
      <NewSigningCardFooter {...props.footerDetails} />
    </div>
  );
};

export default NewSigningCard;
